import styled from 'styled-components';
import theme from 'theme/theme';
import Flex from '../Flex';

const Row = styled(Flex)`
  margin-left:  -${theme.grid.gutter / 2}${theme.grid.unit};
  margin-right:  -${theme.grid.gutter / 2}${theme.grid.unit};
`;

export default Row;
